import { useCssHandles } from '../../../utils/functions';
import SkuSelector from '../../store-components/SkuSelector/SkuSelector';

const CSS_HANDLES = [
	'SKUSelectorContainer',
	'frameAround',
	'seeMoreButton',
	'skuSelectorContainer',
	'skuSelectorInternalBox',
	'skuSelectorItemImageValue',
	'skuSelectorItemImage',
	'skuSelectorItemTextValue',
	'skuSelectorItem',
	'skuSelectorNameContainer',
	'skuSelectorNameSeparator',
	'skuSelectorName',
	'skuSelectorOptionsList',
	'skuSelectorSelectorImageValue',
	'skuSelectorSubcontainer',
	'skuSelectorTextContainer',
	'valueWrapper',
] as const;

interface Props {
	skuItems: any;
	skuSelected?: any;
	onSKUSelected?: (skuId: string) => void;
	maxItems?: number;
	visibility?: 'always' | 'more-than-one';
	seeMoreLabel: string;
	hideImpossibleCombinations?: boolean;
	showValueNameForImageVariation?: boolean;
	showValueForVariation?: 'none' | 'image' | 'all';
	imageHeight?: any;
	imageWidth?: any;
	thumbnailImage?: string;
	visibleVariations?: string[];
	showVariationsLabels?: boolean;
	variationsSpacing?: number;
	showVariationsErrorMessage?: boolean;
	initialSelection?: 'complete' | 'image' | 'empty';
	displayMode?: any;
	sliderDisplayThreshold?: number;
	sliderArrowSize?: number;
	sliderItemsPerPage?: any;
	blockClass?: any;
}

function ProductSummarySkuSelector(props: Props) {
	const { handles }: any = useCssHandles('vtex-product-summary-2-x', CSS_HANDLES, props.blockClass);

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
		<div className={handles.SKUSelectorContainer}>
			<SkuSelector {...props} />
		</div>
	);
}

export default ProductSummarySkuSelector;
